import { render, staticRenderFns } from "./recordNotes.vue?vue&type=template&id=05222492&"
import script from "./recordNotes.vue?vue&type=script&lang=js&"
export * from "./recordNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports